export abstract class ArrayUtils {
    public static mergeUInt8Arrays(arr1: Uint8Array, arr2: Uint8Array): Uint8Array {
        var mergedArray = new Uint8Array(arr1.length + arr2.length);
        mergedArray.set(arr1);
        mergedArray.set(arr2, arr1.length);
        return mergedArray;
    }
}